import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

function EntityTabs({ tabsData }) {
  const [currentTab, setCurrentTab] = useState(new URLSearchParams(window.location.search).get('subTab') || tabsData?.[0]?.key);

  useEffect(() => {
    if (currentTab) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('subTab', currentTab);
      window.history.pushState(null, null, `?${urlParams}`);
    }
  }, [currentTab]);

  const getDataSource = () => tabsData.map((tab, index) => ({ ...tab, index }));

  return (
    <Tabs activeKey={currentTab} onChange={setCurrentTab}>
      {getDataSource()?.map((tab) => (
        <TabPane tab={tab.name} key={tab.key}>
          {tab.component}
        </TabPane>
      ))}
    </Tabs>
  );
}


export default EntityTabs;
